// @flow

import {
  createAuthenticatedHttpClient,
  localiseUrl
} from 'src/modules/seek-api-request';
import { savedSearchesResourceApi } from 'src/config';

const updateSavedSearchLastExecutionDate = ({
  id,
  lastExecutionDateUtc,
  locale
}: {
  id: string,
  lastExecutionDateUtc: string,
  locale: Locale
}): Promise<void> => {
  return createAuthenticatedHttpClient().send({
    method: 'put',
    timeout: 500,
    url: localiseUrl(locale, `${savedSearchesResourceApi}/${id}`),
    data: { lastExecutionDateUtc },
    label: 'dashboard',
    withCredentials: true
  });
};

export default {
  updateSavedSearchLastExecutionDate
};
